module.exports = __webpack_public_path__ + "img/industry2.294dc7c4.png";